// El router usa hash history, así que navegamos a las secciones por scroll en vez de "#ancla"
export function scrollToSection(id: string): void {
  document
    .getElementById(id)
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
}
